import React from 'react';
import { triggerChat } from '@/utils/chatTrigger';

const Navbar = ({ onLogoClick }) => {
  return (
    <nav className="sticky top-0 z-50 w-full bg-navy/90 backdrop-blur-lg border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <button 
              onClick={triggerChat}
              className="px-6 py-2.5 rounded-md bg-gold text-navy font-bold text-sm tracking-wide uppercase transition-all hover:bg-gold-hover hover:shadow-[0_0_15px_rgba(245,166,35,0.4)] active:scale-95"
            >
              Book a Demo
            </button>
          </div>
          <div className="flex-shrink-0 flex items-center">
            <button 
              onClick={onLogoClick}
              className="flex items-center focus:outline-none transition-transform active:scale-95 group"
              title="Admin Panel"
            >
              <img 
                src="https://media-manager-c.questera.ai/greta-media/53257d18d934c13deb15172e6d977d0c36a3dd097c5c5cf609cb857dac040a3963b23aa6d7b2ab716a4b1aba01045119/images/aW1hZ2UvcG5n/74bbba00a2df2b2cb399e3d568aceadd.png" 
                alt="AgentOnDemand Logo" 
                className="h-10 md:h-12 w-auto object-contain group-hover:drop-shadow-[0_0_8px_rgba(245,166,35,0.3)]" 
              />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;